import ProgressBarComponent, {
  type ProgressBarComponentProps,
} from '@components/progressBar/ProgressBar';
import { type FC } from 'react';
import { numericFormatter } from 'react-number-format';

interface TableProgressBarProps extends ProgressBarComponentProps {
  hideCompletedNumber?: boolean;
}

const TableProgressBar: FC<TableProgressBarProps> = ({
  completed,
  maxCompleted,
  hideCompletedNumber = false,
  maxWidth,
  enableNegativeBar,
}) => {
  return (
    <div className="flex flex-1 items-center gap-4">
      <ProgressBarComponent
        completed={completed}
        maxCompleted={maxCompleted}
        maxWidth={maxWidth}
        enableNegativeBar={enableNegativeBar}
      />
      <div className="flex gap-1 color-gray-50 w-[80px]">
        <span className="font-bold">
          {hideCompletedNumber
            ? '-'
            : numericFormatter(completed.toString(), {
                decimalSeparator: ',',
                thousandSeparator: '.',
                decimalScale: 1,
                suffix: '%',
              })}
        </span>

        <span>/</span>
        <span>
          {numericFormatter(maxCompleted.toString(), {
            decimalSeparator: ',',
            thousandSeparator: '.',
            decimalScale: 1,
            suffix: '%',
          })}
        </span>
      </div>
    </div>
  );
};
export default TableProgressBar;
